import React from 'react';
import PropTypes from 'prop-types';
import ReportIssueBase from '../reportIssue/ReportIssueBase';

const AlarmInProduct = ({ ...props }) => {
  const { mobile, motiveId, product, type, profile, onData } = props;

  return (
    <ReportIssueBase
      name="AlarmInProduct"
      label="Descríbenos el inconveniente"
      buttonText="Enviar"
      mobile={mobile}
      motiveId={motiveId}
      product={product}
      type={type}
      profile={profile}
      onData={onData}
    />
  );
};

AlarmInProduct.propTypes = {
  mobile: PropTypes.bool,
  motiveId: PropTypes.string,
  type: PropTypes.string,
  product: PropTypes.object,
  profile: PropTypes.object,
  onData: PropTypes.func,
};

export default AlarmInProduct;
